var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdfChapterTemplate',{attrs:{"page-title":"《中国新闻传播学年鉴》","section-label":"传播平台","section-route":_vm.sectionRoute,"pager-aria-label":"页码切换","layout-xml-path":"/pdf/zhongguoxinwenchuanboxuenianjian/layout.xml","crop":_vm.crop,"pages":_vm.pages,"top-strip-image":_vm.topStripImage,"hero-background-image":_vm.heroBackgroundImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }